import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    registerInfo: {},
    shareVisible: true
  },
  mutations: {
        // 设置注册信息
    SET_REGISTER_INFO(state, info) {
      // 参数校验：确保 info 是一个对象且不为 null
      if (typeof info !== 'object' || info === null) {
        console.warn('SET_REGISTER_INFO: info 必须是一个非空对象');
        return;
      }
    
      // 使用 JSON 深拷贝避免引用共享（适用于可序列化对象）
      try {
        state.registerInfo = JSON.parse(JSON.stringify(info));
      } catch (error) {
        console.error('SET_REGISTER_INFO: 对象深拷贝失败', error);
      }
    },
    // 修改按钮显示状态的方法
    SET_SHARE_VISIBLE(state, visible) {
      state.shareVisible = visible;
    }
  },
  actions: {
    // 更新注册信息
    setRegisterInfo({ commit }, info) {
      // 参数校验
      if (typeof info !== 'object' || info === null) {
        console.warn('setRegisterInfo: info 参数必须是一个对象');
        return;
      }
    
      // 深拷贝防止引用问题
      const safeInfo = JSON.parse(JSON.stringify(info));
    
      commit('SET_REGISTER_INFO', safeInfo);
    },
    // 异步修改按钮状态（如果需要）
    setButtonVisible({ commit }, visible) {
      commit('SET_SHARE_VISIBLE', visible);
    }
  },
  getters: {
  },
  modules: {
    //
  }
})
